module.exports = __webpack_public_path__ + "img/ccv.9f231341.svg";